import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginModal from '../../components/LoginModal.js';
import { GetApi, PostApi } from '../../services/CommonService2.js';
import { Styles } from './styles/account.js';
import axios from 'axios';
let apiurl = "https://asseshub.com";
// let apiurl ="https://carrertek.com";
// let apiurl = "http://localhost:8080";



function Register(props) {
  var stateinfo = useRef();
  const [fbaddidss, setFbaddidss] = useState("")
  const [tenantId, setTenantId] = useState("")
  const [singnupuser, setSignupUser] = useState("student")
  const [yop, setYop] = useState(false)
  useEffect(() => {
    loadDataFirst()
    var fb = localStorage.getItem('fbAddId')
    if (fb != "") {
      setFbaddidss(fb)
    } else {
      setFbaddidss("VisualpathEdTech")
    }
    // getstate();


  }, [])

  const fields = {
    name: '',
    email: '',
    mobileno: '',
    state: '',
    constituency: '',
    password: '',
    districtid: '',
    fbaddid: '',
    studentedutype: '',
    year: '',
    studentbranch: "",
    roll_number: '',
    mandal: '',
    village: '',
    passedoutyear: "",
  }
  const errors = {
    name: '',
    email: '',
    mobileno: '',
    state: '',
    constituency: '',
    password: '',
    districtid: '',
    studentedutype: '',
    academicyear: '',
    branch: "",
    roll_number: '',
    mandal: '',
    village: '',
    passedoutyear: ""
  }

  const [errorFields, setErrorFields] = useState(errors);
  const [formfields, setFormFields] = useState(fields);
  const [isCheck, setIschecked] = useState(false);
  const [showotp, setShowotp] = useState(false);
  const [stateidd, setStateId] = useState('')
  // const [toggleLogin,setToggleLogin]=useState(false);
  const [modalOpen, setModalOpen] = useState(false)
  const [tenantdata, setTenantData] = useState({});
  const [placeholder, setPlaceholder] = useState("Select Constituency");
  const [statedata, setStateData] = useState([]);
  const [states, setStates] = useState([])
  const [constituencies, setConstituency] = useState([])
  const [collegedata, setCollegeData] = useState([])
  const [otp, setOtp] = useState(null);
  const [selected, setSelected] = useState('');
  const [districtdata, setDistrictData] = useState([]);
  // const [districtid,setDistrictid] =useState(null);






  const { name, email, mobileno, state, constituency, password, districtid, studentedutype, year, studentbranch, roll_number, mandal, village, passedoutyear } = formfields;
  const validateForm = async () => {
    let fields = formfields;
    let errors = {};
    let formIsValid = true;

    if (!fields["name"]) {
      formIsValid = false;
      errors["name"] = "*Please enter  name";
    }
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "*Please enter email";
    }

    if (!fields["mobileno"]) {
      formIsValid = false;
      errors["mobileno"] = "*Please enter mobileno.";
    }

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "*Please enter password.";
    }
    if (!fields["studentedutype"]) {
      if (tenantId != "ffe21ec9") {
        formIsValid = false;
        errors["studentedutype"] = "*Please select studentedutype.";
      }
    }
    if (tenantdata.capturestate == "Yes") {
      if (!fields["state"]) {
        formIsValid = false;
        errors["state"] = "*Please select state.";
      }
    }
    if (tenantdata.capturecollege == "Yes") {
      if (!fields["constituency"]) {
        formIsValid = false;
        errors["constituency"] = "*Please select college.";
      }

    }

    if (tenantdata.capturearea == "Yes") {
      if (!fields["constituency"]) {
        formIsValid = false;
        errors["constituency"] = "*Please select constituency.";
      }
    }
    if (tenantdata.showdistrict == "Yes") {
      if (!fields["districtid"]) {
        formIsValid = false;
        errors["districtid"] = "*Please select region.";
      }
    }
    if (tenantId == "2b7b1a31") {
      if (!fields["roll_number"]) {
        formIsValid = false;
        errors["roll_number"] = "*Please enter roll number.";
      }
    }
    if (!fields["mandal"]) {
      formIsValid = false;
      errors["mandal"] = "*Please enter mandal.";
    }
    if (!fields["village"]) {
      formIsValid = false;
      errors["village"] = "*Please enter village.";
    }

    setErrorFields(errors)
    return formIsValid;

  }


  const handleChange = (e) => {

    e.preventDefault();

    const { name, value } = e.target;

    setFormFields((prevState) => ({
      ...prevState,
      [name]: value,

    }));
    if (e.target.name == "state") {
      // console.log("value nnn", value);
      setStateId(value)
      getCollegeByState(value)
    }

    if (e.target.name == "constituency") {

      setSelected(value)
      // console.log("collge id", value);

    }
    if (e.target.name == "districtid") {

      getconstituencybydistricts(value)

    }




  }



  const history = useHistory();

  const loadDataFirst = async () => {
    var tntId = JSON.parse(localStorage.getItem('tID'))
    setTenantId(tntId)
    const value = localStorage.getItem(`tenantdata${tntId}`);
    if (value !== null) {
      setTenantData(JSON.parse(value));
      let tenanat = JSON.parse(value);
      // console.log("tenantdata", tenanat);

      if (tenanat.capturearea == 'Yes' && tenantdata?.showdistrict == 'No') {
        // console.log("inside condition");
        setPlaceholder("Select Constituency");
        getConsittuencies();
      }
      if (tenanat.capturearea == 'Yes' && tenantdata?.showdistrict == 'Yes') {
        setPlaceholder("Select Constituency");

      }
      if (tenanat.capturecollege == 'Yes') {
        setPlaceholder("Select College");

      }
      if (tenanat.capturestate == 'Yes') {
        // setPlaceholder("Select College");
        getstate();
      }
    }


  }

  const getstate = async () => {
    const reqparam = {
      pageno: "-1",
      query: { status: 'Active', tenant: tenantdata.tenantid },

    }
    const ResponseMessage = await PostApi(reqparam, 'STATES');
    // console.log("ResponseMessage", ResponseMessage.data);
    setStates(ResponseMessage?.data)

    let counter = 0;
    const rowdata = [];
    await ResponseMessage?.data?.reduce(async (promise, res) => {
      await promise;
      const opts = {
        key: res.id,
        value: res.name
      }
      rowdata.push(opts);
      if (counter == ResponseMessage?.data?.length - 1) {

        setStateData(rowdata);
      }
      counter++;
    }, Promise.resolve());

  }
  const getConsittuencies = async () => {
    const reqparam = {
      pageno: "-1",
      tenantid: tenantdata.tenantid,
      query: { status: 'Active' }
    }


    const ResponseMessage = await GetApi(reqparam, 'CONSTITUENCY');
    // console.log("constituency data", ResponseMessage.data);
    setConstituency(ResponseMessage?.data)


    let counter = 0;
    const rowdata = [];
    await ResponseMessage?.data?.reduce(async (promise, res) => {
      await promise;
      const opts = {
        key: res.id,
        value: res.name
      }
      rowdata.push(opts);
      if (counter == ResponseMessage.data.length - 1) {

        // setData(rowdata);
      }
      counter++;
    }, Promise.resolve());



  }

  const getCollegeByState = async (val) => {


    if (tenantdata.showdistrict == 'Yes') {
      const reqparam = {
        pageno: "-1",
        query: { status: 'Active', stateid: val }
      }
      const ResponseMessage = await GetApi(reqparam, 'DISTRICTS');
      let counter = 0;
      const rowdata = [];
      if (ResponseMessage.data.length > 0) {
        await ResponseMessage.data.reduce(async (promise, res) => {
          await promise;
          const opts = {
            key: res.id,
            value: res.name
          }
          rowdata.push(opts);
          if (counter == ResponseMessage.data.length - 1) {

            setDistrictData(rowdata);
          }
          counter++;
        }, Promise.resolve());
      }
    }

    else {
      const reqparam = {
        pageno: "-1",
        tenantid: tenantdata.tenantid,
        query: { status: 'Active', stateid: val }
      }

      const ResponseMessage = await GetApi(reqparam, 'CONSTITUENCY');
      // console.log("collegeeee data", ResponseMessage.data);
      setConstituency(ResponseMessage?.data)
      let counter = 0;
      const rowdata = [];
      if (ResponseMessage?.data?.length > 0) {
        await ResponseMessage?.data?.reduce(async (promise, res) => {
          await promise;
          const opts = {
            key: res.id,
            value: res.name
          }
          rowdata.push(opts);
          if (counter == ResponseMessage?.data?.length - 1) {

            // setData(rowdata);
          }
          counter++;
        }, Promise.resolve());
      }
    }



  }


  const getconstituencybydistricts = async (districtval) => {

    setConstituency([]);
    const reqparam = {
      pageno: "-1",
      query: { status: 'Active', districtid: districtval }
    }
    const ResponseMessage = await GetApi(reqparam, 'CONSTITUENCY');

    let counter = 0;
    const rowdata = [];
    if (ResponseMessage?.data.length > 0) {
      await ResponseMessage.data.reduce(async (promise, res) => {
        await promise;
        const opts = {
          id: res.id,
          name: res.name
        }
        rowdata.push(opts);
        if (counter == ResponseMessage?.data.length - 1) {

          setConstituency(rowdata);
          console.log("row data of constituency", rowdata);
        }
        counter++;
      }, Promise.resolve());
    }

  }

  const sendsms = async (e) => {
    console.log("form fileds data", formfields)
    e.preventDefault();
    const isValid = await validateForm();
    if (isValid) {
      if (tenantId == "2b7b1a31") {
        const hitsresponse = await axios.get(apiurl + "/api/v1/hitsstudents");
        // console.log("response", hitsresponse);
        const found = hitsresponse.data.some(student => student.mobileno === mobileno);
        if (found) {
          const reqdata = {
            username: mobileno,
            query: { tenant: tenantdata.tenantid },
            mobileno: mobileno
          }


          const verifyotpResp = await GetApi(reqdata, 'SENDVERIFYMOBILE');


          if (verifyotpResp.data.id) {

            toast.success('OTP sent successfully to your registered mobile', {
              position: "top-center",
              autoClose: 5000
            })
            setShowotp(true);


          } else {
            if (verifyotpResp.data == 'ALREADY_EXISTS') {

              toast.info("mobile number already exists", {
                position: "top-center",
                autoClose: 5000
              })


            } else {
              toast.info('Failed to send otp to the mobile', {
                position: "top-center",
                autoClose: 5000
              })

            }
          }


        }
        else {
          toast.error('Your Mobile number is not as per HITS Records', {
            position: "top-center",
            autoClose: 5000
          })

        }




      } else {

        const reqdata = {
          username: mobileno,
          query: { tenant: tenantdata.tenantid },
          mobileno: mobileno
        }

        // console.log("reqsms",reqdata);

        const verifyotpResp = await GetApi(reqdata, 'SENDVERIFYMOBILE');

        // console.log("otpp", verifyotpResp.data);

        if (verifyotpResp.data.id) {

          toast.success('OTP sent successfully to your registered mobile', {
            position: "top-center",
            autoClose: 5000
          })
          setShowotp(true);


        } else {
          if (verifyotpResp.data == 'ALREADY_EXISTS') {

            toast.info("mobile number already exists", {
              position: "top-center",
              autoClose: 5000
            })


          } else {
            toast.info('Failed to send otp to the mobile', {
              position: "top-center",
              autoClose: 5000
            })

          }
        }

      }
    }

  }

  const [ismobileverified, setIsMobileVerified] = useState(false);

  const verifysms = async (e) => {
    e.preventDefault();
    const reqdata = {
      query: { tenant: tenantdata.tenantid },
      username: mobileno,
      otp: otp,

    }

    const verifyotpResp = await GetApi(reqdata, 'VERIFYMOBILE');
    console.log("verifyotpResp", verifyotpResp.data);

    if (verifyotpResp.data.id) {
      setIsMobileVerified(true);
      register("abc");

    } else {
      if (verifyotpResp.data == 'INVALID_OTP') {
        toast.info("invalid OTP", {
          position: "top-center",
          autoClose: 5000

        })


      } else if (verifyotpResp.data == 'OTP_EXPIRED') {
        toast.info("OTP expired", {
          position: "top-center",
          autoClose: 5000

        })


      }
      else {

        toast.info("Failed to verify OTP", {
          position: "top-center",
          autoClose: 5000

        })

      }
    }

  }

  const register = async (e) => {
    if (e != "abc") {
      e.preventDefault();
    }


    if (password == '') {
      toast.error('please enter password', {
        position: "top-center",
        autoClose: 5000

      })
    }
    else if (password.length < 6) {
      toast.info('password should be minimum of 6 characters', {
        position: "top-center",
        autoClose: 5000

      })
    }
    else {

      const reqdata = {
        username: mobileno,
        email: email,
        name: name,
        tenantid: tenantdata.tenantid,
        tenant: tenantdata,
        roles: ["USER"],
        subapplicationid: selected,
        stateid: stateidd,
        mobileno: mobileno,
        password: password,
        districtid: districtid,
        fbaddid: fbaddidss,
        studentedutype: studentedutype,
        year: year,
        studentbranch: studentbranch,
        roll_number: roll_number,
        mandal: mandal,
        village: village,
        passedoutyear: passedoutyear
      }

      // console.log(reqdata, "check clenmd data from register")

      const reqData = await GetApi(reqdata, 'SIGNUP');
      console.log("reqData after response", reqData);



      if (reqData.data == 'SUCCESS') {
        toast.success("user was registered succesfully ", {
          position: "top-center",
          autoClose: 5000

        })
        //  openModal()

        props.loginmodal()
        props.closemodal()

      }
      else {
        toast.error("mobile number already exists", {
          position: "top-center",
          autoClose: 5000

        })

      }
    }



  }

  const openModal = () => {
    setModalOpen((prevState) => !prevState);

  };
  const onClickstudent = async () => {
    console.log("student");
    setYop(false)
    setSignupUser("student")
  }

  const onClickfresher = async () => {
    console.log("fresher");
    setYop(true)
    setSignupUser("fresher")
  }




  return (
    <Styles>
      <div class="modal-content shadow-lg rounded-4 border-0 animated-bg" style={{ color: 'white', overflow: 'Hidden', position: 'relative', }}>

        {/* <!-- Background Waves --> */}
        <div class="wave-container">
          <div class="wave wave1"></div>
          <div class="wave wave2"></div>
          <div class="wave wave3"></div>
        </div>

        {/* <div class="modal-header py-4 border-0">
          <button onClick={props.onClose} type="button" class="btn-close bg-white opacity-100 border border-2 border-warning rounded-circle close-btn"
            onclick="closeModal()">
          </button>
        </div> */}

        <div class="modal-body px-4">
          <div className='buttons mb-2 text-center'>
            <button type="button" className={yop ? 'btn btn-outline-light mx-3 py-2 px-3 fw-bold' : 'btn btn-warning mx-3 py-2 px-3 fw-bold'} onClick={onClickstudent}>Student</button>
            <button type="button" className={yop ? 'btn btn-warning mx-3 py-2 px-3 fw-bold' : 'btn btn-outline-light mx-3 py-2 px-3 fw-bold'} onClick={onClickfresher}>Freshers</button>
          </div>

          <form id="form_registration">
            <div class="mb-3 text-center">
              <h5 class="modal-title fs-1 fw-bold">Registration</h5>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label fw-bold">Full Name</label>
                <input type="text" class="form-control p-3 rounded-3 border-0" placeholder={tenantId == "2b7b1a31" ? "Full Name as per HITS records" : "Name"} id="registration_fname" name="name" value={name} onChange={handleChange} />
                <p className='text-danger'>{errorFields.name}</p>
              </div>

              {tenantId == "2b7b1a31" && <div className="form-control">
                <input type="text" placeholder="registration number" id="roll_number" name="roll_number" value={roll_number} onChange={handleChange} />
                <p className='text-danger'>{errorFields.roll_number}</p>
              </div>}

              <div class="col-md-6">
                <label class="form-label fw-bold">Email ID</label>
                <input type="email" placeholder="Email address" class="form-control p-3 rounded-3 border-0" id="registration_email" name="email" value={email} onChange={handleChange} />
                <p className='text-danger'>{errorFields.email}</p>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label fw-bold">Mobile Number</label>
                <input type="text" placeholder="mobile number" class="form-control p-3 rounded-3 border-0" name="mobileno" value={mobileno} onChange={handleChange} />
                <p className='text-danger'>{errorFields.mobileno}</p>

              </div>
              <div class="col-md-6">
                <label class="form-label fw-bold">Password</label>
                <input type="password" placeholder="password" class="form-control p-3 rounded-3 border-0" name="password" value={password} onChange={handleChange} />
                <p className='text-danger'>{errorFields.password}</p>
              </div>
            </div>

            <div class="row mb-3">
              {
                tenantId != "ffe21ec9" ? <div className="col-md-6">
                  <label class="form-label fw-bold">Select Education</label>
                  <select className="form-select p-3 rounded-3 border-0"
                    name="studentedutype" value={studentedutype}
                    onChange={handleChange} ref={stateinfo} >
                    <option value=''>Select Education</option>
                    <option value="btech">Btech</option>
                    <option value="degree">Degree</option>
                    <option value="pg">PG</option>
                  </select>
                  <p className='text-danger'>{errorFields.studentedutype}</p>
                </div> : ""
              }

              {!yop && <p className="col-md-6">
                <label class="form-label fw-bold">Year</label>
                <select className="form-select p-3 rounded-3 border-0"
                  name="year" value={year}
                  onChange={handleChange}
                  ref={stateinfo}


                >
                  <option value='' style={{ padding: "10px" }}>Select Year</option>
                  <option value="1">1st year</option>
                  <option value="2">2nd year</option>
                  <option value="3">3rd year</option>
                  <option value="4">4th year</option>

                </select>
                <p className='text-danger'>{errorFields.year}</p>
              </p>}

              {yop && <p className="col-md-6">
                <label class="form-label fw-bold">Passedout Year</label>
                <input type="text" placeholder="Passedout year" class="form-control p-3 rounded-3 border-0" id="passedoutyear" name="passedoutyear" value={passedoutyear} onChange={handleChange} />
                <p className='text-danger'>{errorFields.passedoutyear}</p>
              </p>}

              {
                tenantId == "2b7b1a31" ? <p className="form-control">
                  <select className="form-control"
                    name="studentbranch" value={studentbranch}
                    onChange={handleChange}
                    ref={stateinfo}


                  >
                    <option value='' style={{ padding: "10px" }}>Select Branch</option>
                    <option value="CSE-DS">CSE-DS</option>
                    <option value="CSE">CSE</option>
                    <option value="CSE-AI/ML">CSE-AI/ML</option>
                    <option value="CSE-IOT">CSE-IOT</option>
                    <option value="ECE">ECE</option>
                    <option value="EEE">EEE</option>
                    <option value="MECH">MECH</option>
                    <option value="CIVIL">Civil</option>
                  </select>
                  <p className='text-danger'>{errorFields.studentbranch}</p>


                </p> : ""
              }


            </div>

            <div class="row mb-4">
              {tenantdata.capturestate == 'Yes' && <div className="col-md-7 mx-auto">
                <label class="form-label fw-bold">State</label>
                <select className="form-select p-3 rounded-3 border-0"
                  name="state" value={state}
                  onChange={handleChange}
                  ref={stateinfo}
                >
                  <option value=''>Select State</option>
                  {states.map(item => (
                    <option
                      key={item.id}
                      value={item.id}


                    >
                      {item.name}
                    </option>
                  ))}
                </select>
                <p className='text-danger'>{errorFields.state}</p>
              </div>}

            

            </div>

            <div className='row mb-4'>
               {tenantdata.showdistrict == 'Yes' && <p className="col-md-6">
                <label class="form-label fw-bold">MP Constituency</label>

                <select className="form-select p-3 rounded-3 border-0"
                  name="districtid" value={districtid}
                  onChange={handleChange}
                  ref={stateinfo}
                >
                  <option value='' style={{ padding: "10px" }}>Select Constituency</option>
                  {districtdata.map(item => (
                    <option
                      key={item.key}
                      value={item.key}


                    >
                      {item.value}
                    </option>
                  ))}
                </select>
                <p className='text-danger'>{errorFields.districtid}</p>
              </p>}

              {(tenantdata.capturearea == 'Yes' || tenantdata.capturecollege == 'Yes') &&
                <div className="col-md-6">
                  <label class="form-label fw-bold">MLA Constituency</label>
                  <select className="form-select p-3 rounded-3 border-0"
                    name="constituency" value={constituency}
                    onChange={handleChange} >

                    <option value=''>{placeholder}</option>
                    {constituencies.map(item => (
                      <option
                        key={item.id}
                        value={item.id} >
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <p className='text-danger'>{errorFields.constituency}</p>
                </div>}
                 
                

            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <label class="form-label fw-bold">Mandal</label>
                <input type="text" placeholder="mandal" class="form-control p-3 rounded-3 border-0" name="mandal" value={mandal} onChange={handleChange} />
                <p className='text-danger'>{errorFields.mandal}</p>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-bold">village</label>
                <input type="text" placeholder="village" class="form-control p-3 rounded-3 border-0" name="village" value={village} onChange={handleChange} />
                <p className='text-danger'>{errorFields.village}</p>
              </div>

            </div>

            {showotp &&

              <div className="col-md-12 d-flex mb-3 justify-content-center text-warning rounded-2">
                <input className='rounded-3' type="text" placeholder="enter 6-digit OTP" pattern="[0-9]{6}" maxLength='6' onChange={(e) => setOtp(e.target.value)} value={otp} />
              </div>
              // <input type="text" pattern="[0-9]{6}" maxlength="6" placeholder="Enter 6-digit OTP" onChange={(value) => console.log("value",value)}/>
            }
            <label >
              <input type="checkbox" id="agree" name="agree" onClick={() => setIschecked({ isCheck: !isCheck })} />
              I agree to the terms and conditions
            </label>

            {!showotp && <button type="submit" class="btn w-100 py-2 mt-3 fs-4 rounded-pill text-white fw-bold sign-up-btn animated-btn" onClick={sendsms}>Sign Up</button>}

            {showotp && !ismobileverified && <button onClick={verifysms} class="btn w-100 py-2 mt-3 fs-4 rounded-pill text-white fw-bold sign-up-btn animated-btn">Verify OTP </button>}

            {showotp && ismobileverified && <button onClick={register} class="btn w-100 py-2 mt-3 fs-4 rounded-pill text-white fw-bold sign-up-btn animated-btn">Continue </button>}

            {showotp && !ismobileverified && <label onClick={sendsms} style={{ textDecorationLine: 'underline' }}>Resend OTP</label>}

            {/* <div className="have_account-btn text-center">
                                        <p>Already have an account? <button onClick={()=>setModalOpen(true)}>Login Here</button></p>
                                    </div> */}
            {modalOpen && <LoginModal onClose={openModal}></LoginModal>}
            {/* <div class="d-flex justify-content-center my-3">
              <p class="mb-0 fs-5">Already have an account?</p>
              <a href="#" class="text-warning ms-1 fs-5 fw-bold hover-link">Log In</a>
            </div> */}
          </form>
        </div>
      </div>


    </Styles>
  )
}

export default Register